import React from 'react';
import PropTypes from 'prop-types';
import PdfGeneratorWrapper from './PdfGeneratorWrapper';
import {
    ALL_STUDENT_SUMMARY_PDF,
    HOME_CONNECT_PDF,
    ALL_PM_GRAPHS_PDF,
    TRO_CLASS_SUMMARY_PDF,
    CLASS_SUMMARY_PDF,
    DUAL_LANGUAGE_CLASS_SUMMARY_PDF,
} from '../../../constants/shared/PdfGenerationConstants';
import { URL } from '../../../constants/shared/ApiConstants';

export const getStudentSummariesPdfData = ({
    letterType,
    studentsData,
    userFirstName,
    userLastName,
    districtName,
    classOrGroupName,
    accountInfo,
}) => ({
    letterType,
    studentsData,
    teacher: {
        firstName: userFirstName,
        lastName: userLastName,
    },
    districtName,
    classOrGroupName,
    accountInfo,
});

export const getPmGraphsPdfData = ({
    letterType,
    userFirstName,
    userLastName,
    districtName,
    schoolName,
    classOrGroupName,
    windowDates,
    currentSchoolYear,
    studentsDataForAllPMGraphs,
    hasLegendForAllPMGraphs: hasLegendSection,
}) => ({
    letterType,
    teacher: {
        firstName: userFirstName,
        lastName: userLastName,
    },
    districtName,
    schoolName,
    classOrGroupName,
    windowDates,
    currentSchoolYear,
    studentSummaries: studentsDataForAllPMGraphs,
    hasLegendSection,
});

export const getHomeConnectPdfData = ({ letterType, letterPages, students, accountInfo }) => ({
    letterType,
    letterPages,
    students,
    accountInfo,
});

export const getTroClassSummaryPdfData = ({
    letterType,
    troClassSummaryData,
    districtName,
    classOrGroupName,
    accountInfo,
}) => ({
    letterType,
    troClassSummaryData,
    districtName,
    classOrGroupName,
    accountInfo,
});

export const getClassSummaryPdfData = ({
    letterType,
    classSummaryData,
    userFirstName,
    userLastName,
    districtName,
    classOrGroupName,
    accountInfo,
}) => ({
    letterType,
    classSummaryData,
    teacher: {
        firstName: userFirstName,
        lastName: userLastName,
    },
    districtName,
    classOrGroupName,
    accountInfo,
});

export const getDualLanguageClassSummaryPdfData = ({
    dualLanguageClassSummaryData,
    userFirstName,
    userLastName,
    districtName,
    classOrGroupName,
    accountInfo,
}) => ({
    dualLanguageClassSummaryData,
    teacher: {
        firstName: userFirstName,
        lastName: userLastName,
    },
    districtName,
    classOrGroupName,
    accountInfo,
});

const PdfGenerator = props => {
    const renderPdf = pdfConfiguration => {
        switch (pdfConfiguration.documentKey) {
            case ALL_STUDENT_SUMMARY_PDF:
                return (
                    <PdfGeneratorWrapper
                        {...props}
                        url={URL.STUDENT_SUMMARIES_PDF_URL}
                        getPdfData={getStudentSummariesPdfData}
                    />
                );
            case HOME_CONNECT_PDF:
                return (
                    <PdfGeneratorWrapper
                        {...props}
                        url={URL.HOME_CONNECT_PDF_URL}
                        getPdfData={getHomeConnectPdfData}
                    />
                );
            case ALL_PM_GRAPHS_PDF:
                return (
                    <PdfGeneratorWrapper
                        {...props}
                        url={URL.ALL_PM_GRAPHS_PDF_URL}
                        getPdfData={getPmGraphsPdfData}
                    />
                );
            case TRO_CLASS_SUMMARY_PDF:
                return (
                    <PdfGeneratorWrapper
                        {...props}
                        url={URL.TRO_CLASS_SUMMARY_PDF_URL}
                        getPdfData={getTroClassSummaryPdfData}
                    />
                );
            case CLASS_SUMMARY_PDF:
                return (
                    <PdfGeneratorWrapper
                        {...props}
                        url={URL.CLASS_SUMMARY_PDF_URL}
                        getPdfData={getClassSummaryPdfData}
                    />
                );
            case DUAL_LANGUAGE_CLASS_SUMMARY_PDF:
                return (
                    <PdfGeneratorWrapper
                        {...props}
                        url={URL.DUAL_LANGUAGE_CLASS_SUMMARY_PDF_URL}
                        getPdfData={getDualLanguageClassSummaryPdfData}
                    />
                );
            default:
                return null;
        }
    };
    return props.pdfConfiguration && renderPdf(props.pdfConfiguration);
};

PdfGenerator.defaultProps = {
    isEnrollmentDataFetched: false,
    isDataReady: false,
    pdfConfiguration: null,
};

PdfGenerator.propTypes = {
    isEnrollmentDataFetched: PropTypes.bool,
    isDataReady: PropTypes.bool,
    pdfConfiguration: PropTypes.object,
};

export default PdfGenerator;
